import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Drawer } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getParamValue } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router";
import _ from "lodash";
import HubLayout from "../Layout";
import AddHub from "../AddHub";

import HubHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_HUB_INFO } from "../../../redux/auth/authType";
import MapBox from "../../common/MapBox";

const HubDetails = (): ReactElement => {
  const [singleHubInfo, setSingleHubInfo] = useState({
    loading: false,
    data: null,
  });
  const [categoryData, setCategoryData] = useState({
    loading: false,
    list: null,
  });
  const [selectedHubForEdit, setSelectedHubForEdit] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const route = useParams();
  const dispatch = useDispatch();

  const fetchHubDetails = useCallback((getHubId) => {
    if (getHubId) {
      try {
        setSingleHubInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/hub/details?id=${getHubId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleHubInfo({
                loading: false,
                data: data?.data?.hub,
              });
              dispatch({
                type: SET_HUB_INFO,
                payload: {
                  hubInfo: {
                    id: data?.data?.hub?.id,
                    name: data?.data?.hub?.name,
                    image: data?.data?.hub?.image,
                    type: data?.data?.hub?.type,
                    deleted: data?.data?.hub?.deleted,
                  },
                },
              });
            } else {
              setSingleHubInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleHubInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleHubInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchHubDetails((route as any)?.hubId);
  }, [fetchHubDetails, (route as any)?.hubId]);

  const getCategoryOptions = useCallback(
    async (value) => {
      setCategoryData({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/category/search?page=0&limit=20&isParent=true&type=${singleHubInfo?.data?.type}&key=${value}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setCategoryData({ loading: false, list: res.data });
        })
        .catch((err) => {
          setCategoryData({ loading: false, list: [] });
          console.error("Category: Error", err);
        });
    },
    [singleHubInfo?.data?.type]
  );

  useEffect(() => {
    if (singleHubInfo?.data?.type) {
      getCategoryOptions("");
    }
  }, [getCategoryOptions]);

  function handleChange(value: any) {
    console.log(`selected ${value}`);
  }

  useEffect(() => {
    if (visible) {
      setSelectedHubForEdit(undefined);
    }
  }, [selectedHubForEdit]);

  useEffect(() => {
    setSelectedHubForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedHubForEdit(null);
    fetchHubDetails((route as any)?.hubId);
  };

  const hub = singleHubInfo?.data;

  return (
    <React.Fragment>
      <HubLayout hubId={(route as any)?.hubId as string}>
        <div className="bg-white">
          <HubHeader
            leftarea={"Hub Details"}
            rightarea={
              <Button
                type="primary"
                onClick={() => setSelectedHubForEdit(singleHubInfo.data)}
                danger
              >
                <EditOutlined /> Edit
              </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Hub Name</span>
                  <span className="info-desc">{hub?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">ID</span>
                  <span className="info-desc">{hub?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Delivery Charge Condition</span>
                  <span className="info-desc">
                    <span
                      className={`radius-btn ${
                        hub?.isFreeDelivery === true ? "true" : "false"
                      }-btn`}
                    >
                      {hub?.isFreeDelivery === true
                        ? "Free Delivery"
                        : "Paid Delivery"}
                    </span>
                  </span>
                </div>

                {hub?.baseDeliveryCharge ? (
                  <div className="single">
                    <span className="info-name">Base Delivery Charge</span>
                    <span className="info-desc ">
                      &#2547;{hub?.baseDeliveryCharge}
                    </span>
                  </div>
                ) : undefined}

                {hub?.minimumAmountForFreeDelivery ? (
                  <div className="single">
                    <span className="info-name">
                      Minimum Amount For Free Delivery
                    </span>
                    <span className="info-desc">
                      &#2547;{hub?.minimumAmountForFreeDelivery}
                    </span>
                  </div>
                ) : undefined}

                <div className="single">
                  <span className="info-name">Type</span>
                  <span className="info-desc">
                    {hub?.type?.replace("_", " ")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${
                        hub?.deleted === true ? "inactive" : "active"
                      }-btn`}
                    >
                      {hub?.deleted === true ? (
                        <>
                          <CloseOutlined className="mr-1" /> Inactive
                        </>
                      ) : (
                        <>
                          <CheckOutlined className="mr-1" /> Active{" "}
                        </>
                      )}
                      {hub?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Created Date</span>
                  <span className="info-desc">
                    {moment(hub?.createdAt).format("lll")}
                  </span>
                </div>

                {visible ? (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(false);
                    }}
                  />
                ) : (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}

                {visible && (
                  <div className="">
                    <h6 className="mt-5 title" style={{ width: "98%" }}>
                      Activity Logs
                    </h6>
                    <div className="inner-body">
                      <div className="single">
                        <span className="info-name">Created Date</span>
                        <span className="info-desc">
                          {moment(hub?.createdAt).format("lll")}
                        </span>
                      </div>

                      {hub?.createdBy?.name ? (
                        <div className="single">
                          <span className="info-name">Created By</span>
                          <span className="info-desc">
                            {hub?.createdBy?.name}
                          </span>
                        </div>
                      ) : undefined}

                      <div className="single">
                        <span className="info-name">Contact</span>
                        <span className="info-desc">
                          {hub?.createdBy?.mobileNumber ||
                            hub?.createdBy?.email}
                        </span>
                      </div>
                    </div>
                    {hub?.updatedAt ? (
                      <div className="inner-body mt-4">
                        <div className="single">
                          <span className="info-name">Updated Date</span>
                          <span className="info-desc">
                            {moment(hub?.updatedAt).format("lll")}
                          </span>
                        </div>

                        {hub?.updatedBy?.name ? (
                          <div className="single">
                            <span className="info-name">Updated By</span>
                            <span className="info-desc">
                              {hub?.updatedBy?.name}
                            </span>
                          </div>
                        ) : undefined}

                        {hub?.updatedBy?.mobileNumber ? (
                          <div className="single">
                            <span className="info-name">Contact</span>
                            <span className="info-desc">
                              {hub?.updatedBy?.mobileNumber ||
                                hub?.updatedBy?.email}
                            </span>
                          </div>
                        ) : undefined}
                      </div>
                    ) : undefined}
                  </div>
                )}
              </div>
              <MapBox
                draggable={false}
                coordinate={{
                  lat: hub?.location?.y,
                  lng: hub?.location?.x,
                }}
              />
            </div>
          </div>

          <Drawer
            title={selectedHubForEdit ? "Edit Hub" : ""}
            width={600}
            onClose={() => {
              setSelectedHubForEdit(null);
            }}
            visible={selectedHubForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedHubForEdit ? (
              <AddHub
                visibleData={selectedHubForEdit}
                onCloseMethod={onClose}
              />
            ) : undefined}
          </Drawer>
        </div>
      </HubLayout>
    </React.Fragment>
  );
};
HubDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default HubDetails;
